import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import { MplTrans } from '@mopla/i18';
import { formatPriceFromCents } from '@mopla/utils';

import {
	EMlpIconTypes,
	EMplVariantTypes,
	MplButton,
	MplIconMessage,
	MplModal,
} from '../../../';

interface ICancellationConfirmationModalV2Props {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
	price: number;
}

export const CancellationConfirmationModalV2: FC<
	ICancellationConfirmationModalV2Props
> = ({ open, onClose, onConfirm, price }) => {
	const { t } = useTranslation('booking');

	return (
		<MplModal
			open={open}
			testId="cancellationConfirmationV2-modal"
			title={t('booked.cancel.confirmation.title')}
			content={
				<Stack gap={3}>
					<Typography variant="b2">
						<MplTrans
							ns="booking"
							i18nKey="booked.cancel.confirmation.note_message"
						/>
					</Typography>
					<MplIconMessage
						type={EMlpIconTypes.Info}
						variant={EMplVariantTypes.Default}
						message={t('booked.cancel.confirmation.info_message')}
						textVariant="l1"
					/>
					<Stack
						direction="row"
						justifyContent="space-between"
						alignItems="center"
					>
						<Typography variant="h5-sb">
							{t('booked.cancel.confirmation.cancellation_fee')}
						</Typography>
						<Typography
							variant="b1-sb"
							data-testid="cancellationConfirmationV2-fee-value"
						>
							{formatPriceFromCents(price)}
						</Typography>
					</Stack>
				</Stack>
			}
			buttons={
				<>
					<MplButton
						fullWidth
						variant="contained"
						onClick={onConfirm}
						testId="cancellationConfirmationV2-confirm-button"
					>
						{t('booked.cancel.buttons.cancel')}
					</MplButton>
					<MplButton
						fullWidth
						variant="outlined"
						onClick={onClose}
						testId="cancellationConfirmationV2-doNotCancel-button"
					>
						{t('booked.cancel.buttons.do_not_cancel')}
					</MplButton>
				</>
			}
		/>
	);
};
